import React from 'react'
import PatientCalendarSummary from '../../../Patient/PatientDetails/PatientCalendar/PatientCalendarSummary/PatientCalendarSummary'
import PatientSummary from '../../../Patient/PatientDetails/PatientCalendar/PatientSummary/PatientSummary'
import CaregiverCalendarSummary from './CaregiverCalendarSummary/CaregiverCalendarSummary'
import CaregiverSummary from './CaregiverSummary/CaregiverSummary'

const Calendar = () => {
  return (
    <div className='pateint_clender d-flex gap-01 '>
      {/* <div className='col-md-2 summary'>
        <CaregiverSummary />
      </div> */}
      <div className='col-md-12 br-left-1 br-clr'>
        <div>
          <CaregiverCalendarSummary />
        </div>

      </div>
    </div>
  )
}

export default Calendar